import { withState } from 'recompose';

export default withState('warning', 'updateWarning', null);
